export default "__VITE_ASSET__B4ZdDr8u__"